import { FPSObserver } from 'components/VideoPlayer/utils/FPSObserver';
import { useEffect, useRef } from 'react';

/**
 * Work out the frames-per-second of a video element.
 */
export function useVideoFPS(
  videoRef: React.RefObject<HTMLVideoElement | null>,
): React.RefObject<{ fps?: number } | undefined> {
  const observerRef = useRef<FPSObserver | undefined>();

  useEffect(() => {
    if (videoRef.current) {
      const observer = new FPSObserver(videoRef.current);
      observerRef.current = observer;

      return () => {
        observer.destroy();
      };
    }
  }, [videoRef]);

  return observerRef;
}
